function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bx-like",
  d: "M22.491,9.5H16.414L17.63,5.851A2.167,2.167,0,0,0,15.574,3H13.828A1.084,1.084,0,0,0,13,3.39L7.906,9.5H5.166A2.167,2.167,0,0,0,3,11.663v9.746a2.167,2.167,0,0,0,2.166,2.166H19.575A2.177,2.177,0,0,0,21.6,22.169l2.986-7.96a1.083,1.083,0,0,0,.069-.38V11.663A2.167,2.167,0,0,0,22.491,9.5ZM5.166,11.663H7.331v9.746H5.166Zm17.326,1.969-2.916,7.776H9.5V10.972l4.838-5.806h1.241l-1.691,5.071a1.081,1.081,0,0,0,1.027,1.426h7.58Z",
  transform: "translate(-3 7.787)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "star-fill",
  transform: "matrix(0.966, 0.259, -0.259, 0.966, 18.302, 0.085)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11606",
  "data-name": "Path 11606",
  d: "M2.994,12.392a.44.44,0,0,1-.619-.491l.688-3.923L.142,5.2a.461.461,0,0,1,.235-.788l4.062-.577L6.25.243a.426.426,0,0,1,.769,0L8.83,3.831l4.062.577a.461.461,0,0,1,.235.788L10.2,7.979l.688,3.923a.44.44,0,0,1-.619.491L6.633,10.522l-3.64,1.871Z",
  transform: "translate(0 0)",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "star-fill-2",
  "data-name": "star-fill",
  transform: "matrix(0.966, -0.259, 0.259, 0.966, 24.516, 19.915)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11606-2",
  "data-name": "Path 11606",
  d: "M1.628,6.739a.239.239,0,0,1-.336-.267l.374-2.133L.077,2.825A.251.251,0,0,1,.205,2.4l2.209-.314L3.4.132a.232.232,0,0,1,.418,0L4.8,2.083,7.01,2.4a.251.251,0,0,1,.128.428L5.549,4.339l.374,2.133a.239.239,0,0,1-.336.267L3.607,5.721,1.628,6.739Z",
  transform: "translate(0 0)",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "star-fill-3",
  "data-name": "star-fill",
  transform: "matrix(0.966, 0.259, -0.259, 0.966, 3.888, 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11606-3",
  "data-name": "Path 11606",
  d: "M1.628,6.739a.239.239,0,0,1-.336-.267l.374-2.133L.077,2.825A.251.251,0,0,1,.205,2.4l2.209-.314L3.4.132a.232.232,0,0,1,.418,0L4.8,2.083,7.01,2.4a.251.251,0,0,1,.128.428L5.549,4.339l.374,2.133a.239.239,0,0,1-.336.267L3.607,5.721,1.628,6.739Z",
  transform: "translate(0)",
  fill: "#fff"
}));

var SvgStarLike = function SvgStarLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star-like",
    width: 33.235,
    height: 31.361,
    viewBox: "0 0 33.235 31.361",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-like.00f0dc48.svg";
export { ForwardRef as ReactComponent };